import { parsePhoneFromString } from './phone';

export const phoneValidator = (phone?: string): string | undefined =>
  parsePhoneFromString(phone).isValid ? undefined : 'Invalid Phone number';
